export default __webpack_public_path__ + "static/media/11-TheBreak.b2f5348a.jpeg";